import React, {useContext} from 'react'
import {HotelCardContext} from 'components/HotelCardContext'

import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'

import {BaseHotelCard} from './BaseHotelCard'
import {GalleryLoading} from './Gallery/GalleryLoading'
import {PropertySummaryLoading} from './PropertySummary/PropertySummaryLoading'
import {TopOfferInfoSkeleton} from './TopOfferInfo/Skeleton'

export const HotelCardDesktopLoading = () => {
  const {isAnchor} = useContext(HotelCardContext)

  return (
    <Box
      marginRight="auto"
      marginBottom={isAnchor ? 's500' : 's000'}
      data-id={isAnchor ? 'anchorHotel' : 'nonAnchorHotel'}
    >
      <BaseHotelCard
        isAnchor={isAnchor}
        galleryComponent={<GalleryLoading />}
        propertySummaryComponent={<PropertySummaryLoading />}
        topOfferComponent={<TopOfferInfoSkeleton />}
        availabilityPaneComponent={null}
        offerListComponent={null}
      />
      {!isAnchor && (
        <Box width="100%" paddingTop="s300" paddingBottom="s300">
          <Divider sideMargin="s400" />
        </Box>
      )}
    </Box>
  )
}
